import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * Mobile button atom. Used in mobile navigation.
 * Background color alternates between connected and not connected mode.
 *
 * @prop href The mobile button href.
 * @prop text The mobile button text.
 * @prop id The mobile button id, must be unique.
 * @slot icon The mobile button image or content.
 * @cssprop --background Background color of the mobile button.
 */
@customElement('nn-generic-button')
export class GenericButton extends LitElement {
  static styles = css`
    :host {
      --background: #edf0f5;
    }
    .generic-cta {
      align-items: center;
      border: none;
      background: #db3c35;
      border-radius: 30px;
      color: #fff;
      cursor: pointer;
      display: inline-flex;
      font-family: 'font-medium';
      font-size: 1.125em;
      height: 50px;
      justify-content: center;
      line-height: 1;
      padding: 0 10px;
      max-width: 100%;
      text-align: center;
      text-decoration: none;
      width: 300px;
      transition: 0.3s;
    }
    .generic-cta:hover {
      background: #000;
      color: #fff;
    }
  `;

  @property({ type: String }) href = '';

  @property({ type: String }) text = '';

  @property({ type: String }) id = '';

  @property({ type: String }) myClass = 'generic-cta';

  @property({ type: String }) title = '';

  render() {
    return html`
      <a
        id="${this.id}"
        href="${this.href}"
        class="${this.myClass}"
        rel="nofollow"
        title="${this.text}"
      >
        ${this.title}
      </a>
    `;
  }
}
